import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from "./_shared/_guard/auth.guard";
import { AuthentificationComponent } from './authentification/authentification.component';
import { environment } from '@environments/environment';
import { RedirectGuard } from './_shared/_guard/redirect.guard';
import { NetworkAwarePreloadStrategy } from './_shared/preload/network-aware-preload-strategy';

const routes: Routes|any[] = [
  {
   path: (environment.adminOnly ? 'testcllaj' : '' ),
   loadChildren: () => import('./_pages/pages.module').then( m => m.PagesModule),
 },
 {
  path: (environment.adminOnly ? 'testforum' : 'forum' ),
  loadChildren: () => import('./_forum/forum.module').then( m => m.ForumModule),
},
  {
    path: (environment.adminOnly ? '' : 'dashboard' ),
    loadChildren: () => import('./admin/admin.module').then( m => m.AdminPageModule)
  },
  // {
  //   path: 'bdcs',
  //   component: BondecommandesComponent,
  //   canActivate:[AuthGuard],
  //   roles:['SUPER_ADMIN','ADMIN','CLIENT_PRO']
  // },
  { path: "connexion", component: AuthentificationComponent },
  { path: "auth/login", component: AuthentificationComponent },
  { path: "auth/logout", component: AuthentificationComponent },
  { path: "auth/signin", component: AuthentificationComponent },
  { path: "auth/authverify", component: AuthentificationComponent },
  { path: "auth/resetpassword", component: AuthentificationComponent },
  // Redirection de l'ancien lien vers la nouvelle page Angular
  { path: 'activer-profil-login', redirectTo: '/auth/authverify', pathMatch: 'full' },
  { path: "", redirectTo: "/", pathMatch: "full" },
  { path: "**", redirectTo: "/", pathMatch: "full" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    preloadingStrategy: NetworkAwarePreloadStrategy, onSameUrlNavigation: 'reload', initialNavigation: 'enabledBlocking'
})
  ],
  providers:[],
  exports: [RouterModule]
})
export class AppRoutingModule { }
